import {
  Card,
  CardHeader,
  Stack,
  IconButton,
  ButtonGroup,
  Button,
  Tooltip,
} from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialTypography from "../components/MaterialTypography";
import { useEffect, useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import React from "react";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import { apicall } from "../Integration/apicall";
import { getalldepartment, getallrecruitmentprocess, getjobids } from "./query";
import RequestDialog from "./requestdialog";
import { updaterecruitmentproceesdata } from "./mutation";
import Swal from "sweetalert2";
import ReusableFilter from "../ReusableFilter";
import { FaRegEye } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";
import AnimatedClockIcon from "../components/Icon/animatedClockIcon";
import { FaFilter } from "react-icons/fa";
import { IoRefreshCircle } from "react-icons/io5";
import MaterialButton from "../components/MaterialButton";

const Reports = () => {
  const nav = useNavigate();
  const [currentrequest] = useState("");
  const [RecruitmentRows, setRecruitmentRows] = useState([]);
  const [filterparam, setfilterparam] = useState([]);


  const [openfilter, setopenfilter] = useState(false);

  const [Assetdata, setAssetdata] = useState({
    assetcharge: "",
    assetchargeStatus: "unchecked",
    remaindertime: "",
    remaindertimeStatus: "",
    Content: "",
    ContentStatus: "",
    ccdata: "",
    ccdataStatus: "",
    assetName: "",
    assetNameStatus: "",
  });

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [Payslip, setPayslip] = useState(null);
  console.log("Payslip:", Payslip);

  const [recruitmentdata, setrecruitmentdata] = useState({});

  const [filtereddata, setfiltereddata] = useState([]);

  const handlerecruitmentchange = (field, value) => {
    setrecruitmentdata((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const Viewappointment = (id) => {
    nav("/appointment", { state: id });
  };

  const ViewOfferletter = (id) => {
    nav("/recruitment/Offer", { state: id });
  };

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    Promise.all([apicall(getalldepartment), apicall(getjobids)]).then(
      ([departmentdata, jobdata]) => {
        setPageState({ ...pageState, loading: true });
        console.log("department res", departmentdata?.data?.data);
        console.log("job res", jobdata?.data?.data);
        let departments = departmentdata?.data?.data?.allDepartment;
        let jobs = jobdata?.data?.data?.allStaffRequests;
        console.log(jobs, "alljobs found");

        jobs = jobs?.map((job) => ({
          value: job?.jobid,
          label: job?.jobid,
          field: "jobid",
        }));

        departments = departments?.map((department) => ({
          value: department?.departmentName,
          label: department?.departmentName,
          field: "department",
        }));

        setfilterparam([
          {
            field: "JobId",
            options: jobs,
          },
          {
            field: "department",
            options: departments,
          },
        ]);
      }
    );
  }, []);

  const [SelectAssertCC, setSelectAssertCC] = useState([]);

  const handlenda = (recruirement) => {
    console.log(recruirement, "recdata");
    nav("/Nda", {
      state: {
        candidateName:
          recruirement?.technicalFeedback?.sourcingScreening?.candidateName,
        employeeAddress: recruirement?.technicalFeedback?.employeeAddress,
        location: recruirement?.technicalFeedback?.sourcingScreening?.location,
      },
    });
  };

  const RecruitmentColumns = [
    {
      field: "jobid",
      headerName: "Job ID",
      width: 130,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "candidateName",
      headerName: "Name",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "position",
      headerName: "Position",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "documentVerification",
      headerName: "Document Verification",
      width: 150,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "nda",
      headerName: "NDA",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "appointmentLetter",
      headerName: "Appointment Letter",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "offerLetter",
      headerName: "Offer Letter",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "hrInduction",
      headerName: "HR Induction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "technicalInduction",
      headerName: "Technical Induction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "teamIntro",
      headerName: "Team Introduction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "assestHandover",
      headerName: "Asset Handover",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "hrmsAccess",
      headerName: "HRMS Access",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "handoverToManager",
      headerName: "Handover To Manager",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
  ];

  const [open, setOpen] = React.useState(false);

  const checkAllAssertFields = () => {
    let allowSubmit = false;
    if (
      // staffrequest.jobidStatus === "success" &&
      Assetdata.assetNameStatus === "success" &&
      Assetdata.assetchargeStatus === "success" &&
      Assetdata.remaindertimeStatus === "success" &&
      Assetdata.ContentStatus === "success" &&
      SelectAssertCC != ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  // const checkAllOnboardFields = () => {
  //   let allowSubmit = false;
  //   if (
  //     Onboard.todataStatus === "success" &&
  //     Onboard.contentStatus === "success" &&
  //     selectedOptions != ""
  //   ) {
  //     allowSubmit = true;
  //   } else {
  //     allowSubmit = false;
  //   }
  //   return allowSubmit;
  // };
  // const checkAllOfferFields = () => {
  //   let allowSubmit = false;
  //   if (
  //     Offerletter.CtcStatus === "success" &&
  //     Offerletter.salarystructureStatus === "success" &&
  //     Offerletter.basicPercentageStatus === "success" &&
  //     Offerletter.joiningdateStatus === "success"
  //   ) {
  //     allowSubmit = true;
  //   } else {
  //     allowSubmit = false;
  //   }
  //   return allowSubmit;
  // };

  // const handledete = async () => {
  //   try {
  //     const response = await axios.post(BASEURL, {
  //       query: Deletepayslip,
  //       variables: {
  //         id: "45",
  //       },
  //     });

  //     console.log("responsedelete:", response.data);
  //   } catch (error) {
  //     console.log("DeleteError:", error);
  //   }
  // };

  useEffect(() => {
    getrecruitmentprocess();
  }, []);

  const handleupdaterecruitment = (feild, id) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are You Sure to Proceed Further ?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        updaterecruitmentprocess(feild, id);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const updaterecruitmentprocess = (feild, id) => {
    apicall(updaterecruitmentproceesdata, {
      id,
      input: {
        [feild]: true,
      },
    })
      .then((res) => {
        if (res.success) {
          const success = res?.data?.data?.updateRecruitmentProcess?.success;
          const message = res?.data?.data?.updateRecruitmentProcess?.message;

          Swal.fire({
            position: "center",
            icon: success ? "success" : "error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Cannot Able To update Procedure !",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Able To update Procedure !",
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .finally(() => {
        getrecruitmentprocess();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      });
  };

  const getrecruitmentprocess = () => {
    apicall(getallrecruitmentprocess)
      .then((res) => {
        if (res?.success) {
          console.log(
            res?.data?.data?.allRecruitmentAndHiredFeedback,
            "recdataa"
          );

          let recruitment_data =
            res?.data?.data?.allRecruitmentAndHiredFeedback;
          recruitment_data = recruitment_data?.map((recruitment, ind) => ({
            id: ind + 1,
            recruitment_id: recruitment?.recruitmentProcess?.id || -1,
            jobid: recruitment?.technicalFeedback?.sourcingScreening?.jobid,
            candidateName:
              recruitment?.technicalFeedback?.sourcingScreening?.candidateName,
            position:
              recruitment?.technicalFeedback?.sourcingScreening?.position,
            department:
              recruitment?.technicalFeedback?.sourcingScreening?.department,
            hirringstatus: recruitment?.technicalFeedback?.hiringStatus,
            documentVerification: recruitment?.recruitmentProcess
              ?.documentVerification ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            nda: recruitment?.recruitmentProcess?.nda ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlenda(recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegEye color="#0B1D51" size={20} />
                </IconButton>
              </td>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            appointmentLetter: recruitment?.recruitmentProcess
              ?.appointmentLetter ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    Viewappointment(
                      recruitment?.recruitmentProcess
                        ?.appointmentLetterInstance?.[0]?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegEye color="#0B1D51" size={20} />
                </IconButton>
              </td>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            offerLetter: recruitment?.recruitmentProcess?.offerLetter ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    ViewOfferletter(
                      recruitment?.recruitmentProcess?.offerSalary?.[0]?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegEye color="#0B1D51" size={20} />
                </IconButton>
              </td>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            hrInduction: recruitment?.recruitmentProcess?.hrInduction ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            teamIntro: recruitment?.recruitmentProcess?.teamIntro ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            technicalInduction: recruitment?.recruitmentProcess
              ?.technicalInduction ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            assestHandover: recruitment?.recruitmentProcess?.assestHandover ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),
            hrmsAccess: recruitment?.recruitmentProcess?.hrmsAccess ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),

            handoverToManager: recruitment?.recruitmentProcess
              ?.handoverToManager ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <AnimatedClockIcon size={20} color="#FF6F00" />
              </MaterialBox>
            ),
          }));

          setRecruitmentRows(recruitment_data);
          setfiltereddata(recruitment_data);
        } else {
          alert("Something Went Wrong Try After Sometime !");
        }
      })
      .catch((err) => {
        alert("Cannot Able to Recruitment Data ", err?.message);
      })
      .finally(() => {
          setPageState({ ...pageState, loading: false });
      });
  };
  const handleclosefilter = () => {
    setopenfilter(false);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Reports
                  </MaterialTypography>
                </Stack>
                <Stack direction="row">
                  <ButtonGroup variant="outlined" size="small" color="#000">
                    <Tooltip title="Filter the table" disableInteractive arrow>
                      <MaterialButton onClick={() => setopenfilter(true)}>
                        <FaFilter size={16} color="black" />
                      </MaterialButton>
                    </Tooltip>
                    <Tooltip title="Refresh/Reset the table" disableInteractive arrow>
                      <MaterialButton onClick={getrecruitmentprocess}>
                        <IoRefreshCircle size={20} color="black" />
                      </MaterialButton>
                    </Tooltip>
                  </ButtonGroup>
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={RecruitmentRows}
          columns={RecruitmentColumns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={""}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No recruitment details found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any recruitment details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
      <MaterialBox>
        <RequestDialog
          open={open}
          setOpen={setOpen}
          currentrequest={currentrequest}
          recruitmentdata={recruitmentdata}
          handlerecruitmentchange={handlerecruitmentchange}
          setrecruitmentdata={setrecruitmentdata}
          confirmationDialog={confirmationDialog}
          setConfirmationDialog={setConfirmationDialog}
          getrecruitmentprocess={getrecruitmentprocess}
        />

        <ReusableFilter
          filterparam={filterparam}
          setfilterparam={setfilterparam}
          setfilterdata={setRecruitmentRows}
          openfilter={openfilter}
          handleclosefilter={handleclosefilter}
          unfiltereddata={RecruitmentRows}
        />
      </MaterialBox>
    </DashboardLayout>
  );
};
export default Reports;
